
(function(){
'use strict';
if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
var el=document.getElementById('ol-mascot'),tip=document.getElementById('ol-mascot-tip');
if(!el||!tip)return;
var goal=null,pos=null,frame=0,expanded=false;
var harvestMode=false,harvestGoal=null,basketAcquired=false,hasBeenIntroduced=false;
var basketShown=false,pickupTimer=0;
var produceGroup=el.querySelector('[data-ol-companion-produce]');
function clamp(a,b,c){return Math.min(c,Math.max(b,a))}
function locateTip(){
if(!pos)return;
var w=Math.min(252,innerWidth-32);
tip.style.left=Math.round(clamp(pos.x-w-27,12,innerWidth-w-12))+'px';
tip.style.top=Math.round(clamp(pos.y-28,15,Math.max(15,innerHeight-181)))+'px'
}
function toggle(on){expanded=!!on&&document.body.classList.contains('ol-mascot-floating');tip.hidden=!expanded;el.setAttribute('aria-expanded',String(expanded));if(expanded)locateTip()}
function render(){
var w=el.offsetWidth||56,h=el.offsetHeight||66;
el.style.transform='translate3d('+(pos.x-w/2).toFixed(2)+'px,'+(pos.y-h/2).toFixed(2)+'px,0) scale('+pos.s.toFixed(3)+') rotate('+pos.r.toFixed(1)+'deg)';
if(expanded)locateTip()
}
function animate(){
frame=0;if(!goal)return;
if(!pos)pos=Object.assign({},goal);
pos.x+=(goal.x-pos.x)*.19;
pos.y+=(goal.y-pos.y)*.19;
pos.s+=(goal.s-pos.s)*.19;
pos.r+=(goal.r-pos.r)*.19;
render();
if(Math.abs(goal.x-pos.x)+Math.abs(goal.y-pos.y)+80*Math.abs(goal.s-pos.s)+Math.abs(goal.r-pos.r)>.45)queue()
}
function queue(){if(!frame)frame=requestAnimationFrame(animate)}
function displayBasket(shouldShow){
 var ready=!!shouldShow;
 if(ready===basketShown)return;
 basketShown=ready;
 el.classList.toggle('ol-has-basket',ready);
 clearTimeout(pickupTimer);
 el.classList.remove('ol-basket-pickup');
 if(ready){
   basketAcquired=true;
   void el.offsetWidth;
   el.classList.add('ol-basket-pickup');
   pickupTimer=setTimeout(function(){el.classList.remove('ol-basket-pickup')},1050);
 }
}
/* ol-return-dock-2026: one shared home coordinate for harvest and normal floating. */
function getRestPosition(){
 var mobile=innerWidth<750;
 return {x:innerWidth-(mobile?44:75),y:clamp(innerHeight*.57+Math.sin(scrollY/260)*14,mobile?110:150,innerHeight-105),s:1,r:Math.sin(scrollY/310)*4};
}
function update(){
var story=document.getElementById('ol-grow-journey');
var fruit=document.getElementById('ol-grow-handoff');
var mobile=innerWidth<750,rest=getRestPosition(),landingX=rest.x,landingY=rest.y;
if(story&&fruit){
 var r=story.getBoundingClientRect();
 var distance=Math.max(1,story.offsetHeight-innerHeight);
 var progress=clamp(-r.top/distance,0,1);
 var position=fruit.getBoundingClientRect(),atX=position.left+position.width/2,atY=position.top+position.height/2;
 var t=clamp((progress-.80)/.175,0,1);t=t*t*(3-2*t);
 if(progress>.985&&!hasBeenIntroduced){
   hasBeenIntroduced=true;
   try{sessionStorage.setItem('ol-ortino-introduced','1')}catch(e){}
 }
 // Hide basket throughout birth scene, even on backwards scrolling.
 // Pick it up only after moving farther into the page.
 var afterBirth=Math.max(0,innerHeight-r.bottom);
 var pickupDistance=mobile?Math.max(170,innerHeight*.25):Math.max(210,innerHeight*.29);
 displayBasket(hasBeenIntroduced&&afterBirth>=pickupDistance);
 if(!harvestMode)goal={x:atX*(1-t)+landingX*t,y:atY*(1-t)+landingY*t,s:.77+.23*t,r:Math.sin(scrollY/310)*4*t};
 el.style.opacity=String(clamp((progress-.815)/.10,0,1));
 document.body.classList.toggle('ol-mascot-floating',progress>.985);
 if(progress<=.985&&expanded)toggle(false);
}else{
 if(!hasBeenIntroduced){el.style.opacity='0';displayBasket(false);document.body.classList.remove('ol-mascot-floating');return;}
 if(!harvestMode)goal={x:landingX,y:landingY,s:1,r:0};
 el.style.opacity='1';
 document.body.classList.add('ol-mascot-floating');
 displayBasket(true);
}
if(harvestMode&&harvestGoal){
 goal=harvestGoal;
 el.style.opacity='1';
 document.body.classList.add('ol-mascot-floating');
}
if(!pos)pos=Object.assign({},goal);
queue()
}
function setBasketTokens(tokens){
 if(!produceGroup)return;
 produceGroup.replaceChildren();
 (tokens||[]).slice(0,6).forEach(function(item,i){
  if(!item||typeof item.cloneNode!=='function')return;
  var svg=item.cloneNode(true);
  svg.removeAttribute('class');
  svg.setAttribute('x',String(12+(i%3)*20));
  svg.setAttribute('y',String(4+Math.floor(i/3)*9));
  svg.setAttribute('width','26');
  svg.setAttribute('height','30');
  produceGroup.appendChild(svg);
 });
}
window.OrtoLogicOrtino={
 enterHarvest:function(){
  harvestMode=true;
  toggle(false);
  document.body.classList.add('ol-mascot-harvesting');
  el.classList.remove('ol-is-moving','ol-is-picking');
  update();
 },
 moveTo:function(x,y,scale){
  if(!harvestMode)return;
  harvestGoal={x:x,y:y,s:scale||1,r:0};goal=harvestGoal;
  if(!pos)pos=Object.assign({},goal);
  queue();
 },
 leaveHarvest:function(){
  harvestMode=false;harvestGoal=null;
  el.classList.remove('ol-is-moving','ol-is-picking');
  document.body.classList.remove('ol-mascot-harvesting');
  update();
 },
 setBasketTokens:setBasketTokens,
 setAction:function(action){el.classList.toggle('ol-is-moving',action==='move');el.classList.toggle('ol-is-picking',action==='pick')},
 getBasketRect:function(){return el.querySelector('.ol-companion-basket')?.getBoundingClientRect()||el.getBoundingClientRect()},
 getRestPosition:getRestPosition,
 isHarvesting:function(){return harvestMode}
};
function restoreBasketForOtherPages(){
 if(document.getElementById('ol-grow-journey')||!produceGroup)return;
 var labels;
 try{labels=JSON.parse(sessionStorage.getItem('ol-ortino-crops')||'[]')}catch(e){labels=[]}
 if(!Array.isArray(labels))return;
 var ns='http://www.w3.org/2000/svg';
 var shapes=['#c56c50','#88aa6c','#e2a34f','#4e946c','#895695','#d7aa74'];
 var tokens=labels.slice(0,6).map(function(name,i){
  var label=String(name||'').toLowerCase();
  var isGreen=/lattug|spinac|cavol|zucchin|cetriol|basilic|prezzemol|pisell|fagiolin|rucol|bietol/.test(label);
  var isOrange=/carot|peperon/.test(label);
  var isPurple=/melanz/.test(label);
  var svg=document.createElementNS(ns,'svg');
  svg.setAttribute('viewBox','0 0 60 60');
  var circle=document.createElementNS(ns,'ellipse');
  circle.setAttribute('cx','30');circle.setAttribute('cy','34');
  circle.setAttribute('rx',isGreen?'23':'19');circle.setAttribute('ry',isGreen?'16':'19');
  circle.setAttribute('fill',isGreen?'#7fa975':isOrange?'#dba052':isPurple?'#895695':shapes[i%shapes.length]);
  svg.appendChild(circle);
  var leaf=document.createElementNS(ns,'ellipse');
  leaf.setAttribute('cx','33');leaf.setAttribute('cy','14');
  leaf.setAttribute('rx','13');leaf.setAttribute('ry','5');
  leaf.setAttribute('transform','rotate(-27 33 14)');
  leaf.setAttribute('fill','#54845b');
  svg.appendChild(leaf);
  return svg;
 });
 if(tokens.length)setBasketTokens(tokens);
}
function init(){try{hasBeenIntroduced=sessionStorage.getItem('ol-ortino-introduced')==='1'}catch(e){} update();restoreBasketForOtherPages();document.body.classList.add('ol-mascot-ready')}
el.addEventListener('click',function(){toggle(!expanded)});
document.addEventListener('pointerdown',function(e){if(expanded&&!el.contains(e.target)&&!tip.contains(e.target))toggle(false)});
document.addEventListener('keydown',function(e){if(e.key==='Escape')toggle(false)});
window.addEventListener('scroll',update,{passive:true});
window.addEventListener('resize',update,{passive:true});
/* ol-home-resume-visibility-2026 */
/* iOS Safari may restore scroll after DOMContentLoaded. Recompute home position
   once the page is displayed and after its restored layout settles.
   Leave the product branch and the scroll-driven birth completely unchanged. */
var olResumeTimer=0;
function refreshHomeOnResume(){
 if(!document.getElementById('ol-grow-journey'))return;
 update();
 requestAnimationFrame(update);
 clearTimeout(olResumeTimer);
 olResumeTimer=setTimeout(update,800);
}
window.addEventListener('pageshow',refreshHomeOnResume);
document.addEventListener('visibilitychange',function(){if(!document.hidden)refreshHomeOnResume()});
document.addEventListener('shopify:section:load',init);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init()
})();

/* Saluto di Ortino: una volta sola a ogni apertura della homepage. */
(function(){
'use strict';
if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
var bubble=document.getElementById('ol-mascot-welcome');
var mascot=document.getElementById('ol-mascot');
if(!bubble||!mascot)return;
var greeted=false,opening=false,hideTimer=0,cleanupTimer=0;
try{greeted=sessionStorage.getItem('ol-mascot-greeted')==='1'}catch(e){}
function clamp(n,min,max){return Math.min(max,Math.max(min,n))}
function place(){
 if(bubble.hidden)return;
 var r=mascot.getBoundingClientRect(),w=bubble.offsetWidth,h=bubble.offsetHeight;
 bubble.style.left=Math.round(clamp(r.left-w-15,10,Math.max(10,innerWidth-w-10)))+'px';
 bubble.style.top=Math.round(clamp(r.top+r.height/2-35,12,Math.max(12,innerHeight-h-12)))+'px';
}
function hide(){
 clearTimeout(hideTimer);
 bubble.classList.remove('ol-welcome-visible');
 clearTimeout(cleanupTimer);
 cleanupTimer=setTimeout(function(){bubble.hidden=true},320)
}
function show(){
 opening=false;
 if(!document.body.classList.contains('ol-mascot-floating'))return;
 greeted=true;
 try{sessionStorage.setItem('ol-mascot-greeted','1')}catch(e){}
 bubble.hidden=false;
 place();
 requestAnimationFrame(function(){bubble.classList.add('ol-welcome-visible')});
 hideTimer=setTimeout(hide,4700)
}
function check(){
 if(!greeted&&!opening&&document.body.classList.contains('ol-mascot-floating')){
  opening=true;setTimeout(show,700)
 } else if(greeted&&!bubble.hidden) {
  if(!document.body.classList.contains('ol-mascot-floating'))hide();
  else place()
 }
}
mascot.addEventListener('click',hide);
window.addEventListener('scroll',check,{passive:true});
window.addEventListener('resize',place,{passive:true});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',check,{once:true});else check();
})();


/* OrtoLogic Wind v2 — folate più morbide e prima folata anticipata. */
(function(){
 'use strict';
 if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 var mascot=document.getElementById('ol-mascot');
 var gust=document.getElementById('ol-mascot-wind');
 var quote=document.getElementById('ol-mascot-wind-quote');
 var welcome=document.getElementById('ol-mascot-welcome');
 var tip=document.getElementById('ol-mascot-tip');
 if(!mascot||!gust||!quote)return;
 var timer=0,endTimer=0,quoteTimer=0,quoteCloseTimer=0;
 var started=false,blowing=false,first=true,events=0,lastScroll=Date.now();

 /* OrtoLogic Dialogue Rotation v1: messaggi diversi dopo le folate. */
 /* OrtoLogic Seasonal Dialogues v1 — stagioni meteorologiche italiane. */
 var firstLine="Per fortuna ho le radici... Ah no!";
 var seasonalLines={
  primavera:{
   tips:[
    "Primavera: controlla le gelate tardive prima di trapiantare all'aperto.",
    "È il momento di preparare il terreno: smuovilo solo quando non è troppo bagnato.",
    "Le nuove piantine amano la luce. Controlla dove arriva il sole nel tuo orto!",
    "Semina poco per volta: avrai raccolti più distribuiti nel tempo.",
    "In primavera tieni d'occhio le lumache, soprattutto dopo la pioggia.",
    "Prima di seminare, verifica la temperatura del terreno e le esigenze della coltura."
   ],
   jokes:[
    "Primavera! Io sboccio di entusiasmo... anche se sono un pomodorino.",
    "Le giornate si allungano. Le mie radici, invece, non si vedono!",
    "Piove, c'è il sole, poi piove. La primavera è indecisa quanto me!",
    "Sono Ortino: pronto a crescere... purché il vento collabori!"
   ]
  },
  estate:{
   tips:[
    "D'estate controlla il terreno e annaffia preferibilmente nelle ore più fresche.",
    "Uno strato di pacciamatura aiuta a limitare l'evaporazione dell'acqua.",
    "Raccogli spesso zucchine e cetrioli: lasciarli troppo può rallentare la produzione.",
    "Con il caldo, bagna il terreno vicino alle radici anziché sprecare acqua sulle foglie.",
    "Le piante in vaso si asciugano più in fretta: controllale spesso.",
    "Il sole serve, ma nelle ondate di calore alcune colture gradiscono un po' d'ombra."
   ],
   jokes:[
    "Questo sole mi sta facendo diventare passata di pomodoro!",
    "Estate: mi serve acqua, non un tuffo nella salsa!",
    "Se divento tutto rosso, non è timidezza. È stagione!",
    "Il caldo è forte... ma io resto un datterino con carattere!"
   ]
  },
  autunno:{
   tips:[
    "Autunno: raccogli gli ultimi frutti prima delle prime gelate.",
    "Foglie sane e materiale organico possono diventare una buona copertura del suolo.",
    "Prima di piantare l'aglio, controlla il periodo giusto per la tua zona.",
    "Con le giornate più corte, l'orto ha spesso bisogno di meno acqua.",
    "Proteggi le colture delicate quando sono previste gelate.",
    "Approfitta dell'autunno per osservare il terreno e progettare la prossima stagione."
   ],
   jokes:[
    "Autunno: cadono le foglie... e con questo vento quasi cado anch'io!",
    "Sto facendo scorta di pazienza per l'inverno. Di radici ne ho poche!",
    "Le giornate si accorciano. Per fortuna io sono già piccolo!",
    "Tra foglie e folate, oggi l'orto sembra una pista da ballo!"
   ]
  },
  inverno:{
   tips:[
    "In inverno controlla le protezioni delle piante prima delle notti gelide.",
    "Evita di lavorare il terreno quando è fradicio o gelato.",
    "L'inverno è perfetto per progettare rotazioni e distanze per le prossime colture.",
    "I tunnel e i teli vanno arieggiati quando la temperatura lo permette.",
    "Prima di annaffiare in inverno, verifica che il terreno ne abbia davvero bisogno.",
    "Controlla semi e attrezzi: una buona stagione comincia dalla preparazione."
   ],
   jokes:[
    "Brrr! Oggi vorrei essere un pomodorino al forno.",
    "Inverno: io metterei il cappotto... se avessi le braccia!",
    "Fuori gela. Credo che il vento abbia esagerato col frigorifero!",
    "Sto aspettando la primavera. Intanto mi alleno a non volare!"
   ]
  }
 };
 function seasonItaly(){
   var month;
   try{
     month=Number(new Intl.DateTimeFormat("en-US",{timeZone:"Europe/Rome",month:"numeric"}).format(new Date()));
   }catch(e){month=new Date().getMonth()+1;}
   if(month>=3&&month<=5)return "primavera";
   if(month>=6&&month<=8)return "estate";
   if(month>=9&&month<=11)return "autunno";
   return "inverno";
 }
 var tipsLeft=[],jokesLeft=[],lastTip="",lastJoke="",nextTip=true,activeSeason="";
 function refillBank(messages,previous){
   var a=messages.slice();
   for(var i=a.length-1;i>0;i--){
     var j=Math.floor(Math.random()*(i+1)),tmp=a[i];a[i]=a[j];a[j]=tmp;
   }
   if(a.length>1&&a[a.length-1]===previous){
     var pick=a[0];a[0]=a[a.length-1];a[a.length-1]=pick;
   }
   return a;
 }
 function chooseLine(){
   if(first){first=false;return firstLine;}
   var season=seasonItaly();
   if(season!==activeSeason){
     activeSeason=season;
     tipsLeft=[];jokesLeft=[];lastTip="";lastJoke="";
   }
   var useful=nextTip;
   nextTip=!nextTip;
   var collection=seasonalLines[activeSeason];
   if(useful){
     if(!tipsLeft.length)tipsLeft=refillBank(collection.tips,lastTip);
     lastTip=tipsLeft.pop();
     return lastTip;
   }
   if(!jokesLeft.length)jokesLeft=refillBank(collection.jokes,lastJoke);
   lastJoke=jokesLeft.pop();
   return lastJoke;
 }
 function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
 function enabled(){
   return !document.hidden &&
     document.body.classList.contains('ol-mascot-floating') &&
     !document.body.classList.contains('ol-mascot-harvesting') &&
     window.matchMedia('(prefers-reduced-motion: reduce)').matches===false;
 }
 function positionWind(){
   if(gust.hidden)return;
   var r=mascot.getBoundingClientRect();
   gust.style.left=Math.round(clamp(r.left-65,4,Math.max(4,innerWidth-169)))+'px';
   gust.style.top=Math.round(clamp(r.top-23,2,Math.max(2,innerHeight-112)))+'px';
 }
 function positionQuote(){
   if(quote.hidden)return;
   var r=mascot.getBoundingClientRect();
   var w=quote.offsetWidth,h=quote.offsetHeight;
   quote.style.left=Math.round(clamp(r.left-w-19,10,Math.max(10,innerWidth-w-10)))+'px';
   quote.style.top=Math.round(clamp(r.top+r.height*.5-30,12,Math.max(12,innerHeight-h-12)))+'px';
 }
 function hideQuote(){
   clearTimeout(quoteTimer);clearTimeout(quoteCloseTimer);
   quote.classList.remove('ol-wind-quote-visible');
   quoteCloseTimer=setTimeout(function(){quote.hidden=true},300);
 }
 function showQuote(){
   if(!enabled()||(welcome&&!welcome.hidden)||(tip&&!tip.hidden))return;
   clearTimeout(quoteCloseTimer);
   quote.textContent=chooseLine();
   quote.hidden=false;
   positionQuote();
   requestAnimationFrame(function(){quote.classList.add('ol-wind-quote-visible')});
   quoteTimer=setTimeout(hideQuote,4200);
 }
 function stopGust(){
   clearTimeout(endTimer);
   blowing=false;
   mascot.classList.remove('ol-mascot-gusting');
   gust.hidden=true;
 }
 function schedule(ms){
   clearTimeout(timer);
   timer=setTimeout(attempt,ms);
 }
 function attempt(){
   if(!enabled()){
     started=false;
     clearTimeout(timer);
     return;
   }
   if(blowing||(welcome&&!welcome.hidden)||(tip&&!tip.hidden)||Date.now()-lastScroll<2500){
     schedule(6500);
     return;
   }
   blowing=true;events++;
   hideQuote();
   gust.hidden=false;
   /* Gli elementi escono da display:none e ripartono senza reflow forzati. */
   positionWind();
   mascot.classList.add('ol-mascot-gusting');
   endTimer=setTimeout(function(){
     stopGust();
     showQuote();
     // Home: 2 minuti tra le frasi, sottratta la folata di 2,75 s.
     // Altre pagine (incluse le pagine prodotto): cadenza originale invariata.
     schedule(document.getElementById('ol-grow-journey')?117250:(42000+Math.floor(Math.random()*18000)));
   },2750);
 }
 function check(){
   lastScroll=Date.now();
   if(!enabled()){
     clearTimeout(timer);
     started=false;
     if(blowing)stopGust();
     if(!quote.hidden)hideQuote();
     return;
   }
   if(!started){
     started=true;
     // The home birth greeting is separate; the next automatic phrase starts after ~2 minutes.
     schedule(document.getElementById('ol-grow-journey')?117250:(10500+Math.floor(Math.random()*4000)));
   }
   if(blowing)positionWind();
   if(!quote.hidden)positionQuote();
 }
 mascot.addEventListener('click',function(){
   if(!quote.hidden)hideQuote();
 });
 window.addEventListener('scroll',check,{passive:true});
 window.addEventListener('resize',function(){positionWind();positionQuote()},{passive:true});
 document.addEventListener('visibilitychange',function(){
   if(document.hidden){clearTimeout(timer);started=false;if(blowing)stopGust();if(!quote.hidden)hideQuote();}
   else check();
 });
 document.addEventListener('shopify:section:load',check);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',check,{once:true});
 else check();
})();

/* OrtoLogic reward: feedback immediato, senza alterare l'invio nativo Shopify. */
(function(){
'use strict';
document.addEventListener('submit',function(event){
 var form=event.target;
 if(!form||!form.matches||!form.matches('form.olj__rewardform'))return;
 var button=form.querySelector('button[type="submit"]');
 if(!button||button.dataset.oljPending==='1')return;
 button.dataset.oljPending='1';
 button.textContent='Un momento, preparo il tuo codice…';
 button.setAttribute('aria-busy','true');
 button.style.cursor='progress';
 button.style.opacity='.82';
 var progress=form.querySelector('[data-olj-submit-progress]');
 if(!progress){
  progress=document.createElement('p');
  progress.setAttribute('data-olj-submit-progress','');
  progress.setAttribute('role','status');
  progress.textContent='Richiesta in corso. Il codice comparirà qui dopo la conferma.';
  progress.style.cssText='margin:10px 0;color:#203f32;font:600 13px/1.5 Arial,sans-serif';
  form.appendChild(progress);
 }
 try{sessionStorage.setItem('ol-mascot-greeted','1')}catch(e){}
},true);
})();
